
export const state = {
    routeHistory: []
};
export const mutations = {
    PUSH_ROUTE(state, route) {
        state.routeHistory.push(route);
      },
};
export const getters = {
};

export const actions = {
    addRoute({ commit, state  }, route) {
        //if the currnet route is the same as the last saved, don't save
        if(route == state.routeHistory[state.routeHistory.length - 1]){
            return
        }
        commit("PUSH_ROUTE", route);
      },
};

export default {
  state,
  getters,
  actions,
  mutations
};
